import React, { use, useEffect, useState } from 'react';
import { SplitterOnChangeEvent, SplitterPaneProps } from '@progress/kendo-react-layout';
import { debounce } from 'lodash';
import CoreSplitter from '@components-clean/core/core-splitter';
import { InfoField } from '@components-clean/core/info-field';
import CriticalToQualityDetail from '@pages-clean/risk-assessment/critical-to-quality-factors/sections/ctq-factors/sections/ctq-detail/ctq-detail';
import CriticalToQualityGrid from '@pages-clean/risk-assessment/critical-to-quality-factors/sections/ctq-factors/sections/ctqf-grid';
import RisksReviewsGrids from '@pages-clean/risk-assessment/critical-to-quality-factors/sections/ctq-factors/sections/risks-reviews';
import { CTQFactorsContext } from '@pages-clean/risk-assessment/interfaces/context';
import { useTranslation } from '@hooks/index';
import { SplitterOrientation } from '@utils/constants';

const Factors = () => {
    const { t } = useTranslation('ram', { keyPrefix: 'ctqf.ctqFactors' });
    const [panes, setPanes] = useState<SplitterPaneProps[]>([{ size: '40%', min: '15px' }, { min: '35px' }]);
    const [showDetail, setShowDetail] = useState<boolean>(true);
    const { current } = use(CTQFactorsContext);
    const onPaneChange = (event: SplitterOnChangeEvent) => {
        debounce(() => setPanes(event.newState), 20);
    };

    const [selectedRiskId, setSelectedRiskId] = useState<string | null>(null);

    useEffect(() => {
        const observer = new ResizeObserver((entries) => {
            const root = document.documentElement;
            const body = entries[0];

            root.style.setProperty('--ram-ctqf-detail-height', '161px');

            if (body.contentRect.height <= body.contentRect.width) {
                if (body.contentRect.height <= 768 || body.contentRect.width <= 1024) {
                    root.style.setProperty('--ram-ctqf-detail-height', '0px');
                    setShowDetail(false);
                } else setShowDetail(true);
            } else if (body.contentRect.height >= body.contentRect.width) {
                if (body.contentRect.width <= 768 || body.contentRect.height <= 1024) {
                    root.style.setProperty('--ram-ctqf-detail-height', '0px');
                    setShowDetail(false);
                } else setShowDetail(true);
            } else setShowDetail(true);
        });
        observer.observe(document.body);

        return () => observer.disconnect();
    }, []);

    return (
        <div style={{ height: 'calc(100cqh - 31px)', maxWidth: 'calc(100vw - 20px - var(--left-pagenav-menu-width))' }}>
            <CoreSplitter
                className="!k-h-full"
                orientation={SplitterOrientation.vertical}
                data-testid="ctq-factors-splitter"
                alignmentValues={panes}
                onChange={onPaneChange}
            >
                <div className="k-h-full">
                    <CriticalToQualityGrid setSelectedRiskId={setSelectedRiskId} />
                </div>
                {current.selectionState.selectedItemsCount === 0 ? (
                    <div className="k-h-full">
                        <InfoField type="Info" message={t('noParentRecordSelected')} layout="center" />
                    </div>
                ) : current.selectionState.selectedItemsCount > 1 ? (
                    <div className="k-h-full">
                        <InfoField type="Info" message={t('multipleRecordsSelected')} layout="center" />
                    </div>
                ) : (
                    <>
                        {showDetail && <CriticalToQualityDetail />}
                        <RisksReviewsGrids selectedRiskId={selectedRiskId} />
                    </>
                )}
            </CoreSplitter>
        </div>
    );
};

export default Factors;
